// 微信授权配置
export default {
    appId: "这里填你的公众号APPID",
    // 回调地址，必须和公众号后台配置一致，必须线上域名
    redirectUri: encodeURIComponent("https://你的域名.com/"),
    scope: "snsapi_base", // snsapi_base 静默授权，snsapi_userinfo 主动授权

    // 生成授权链接
    getAuthUrl() {
        return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appId}&redirect_uri=${this.redirectUri}&response_type=code&scope=${this.scope}&state=STATE#wechat_redirect`;
    },

    // 是否微信浏览器
    isWechat() {
        return /micromessenger/i.test(navigator.userAgent);
    },

    // 获取URL中的 code
    getCode() {
        const code = new URLSearchParams(location.search).get("code");
        return code || null;
    },
};
